import { render, staticRenderFns } from "./DistributeRecordDrawer.vue?vue&type=template&id=4e1977ef&scoped=true"
import script from "./DistributeRecordDrawer.vue?vue&type=script&lang=js"
export * from "./DistributeRecordDrawer.vue?vue&type=script&lang=js"
import style0 from "./DistributeRecordDrawer.vue?vue&type=style&index=0&id=4e1977ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1977ef",
  null
  
)

export default component.exports